<div class="community-page">
  <section class="community-hero">

<section class="community-hero">
  <div class="hero-content">

    <div class="hero-brand">
      <img
        [src]="branding.logoUrl()"
        alt="McDonald's"
      />

      <div class="hero-kicker">
        <span class="kicker-line"></span>
        <span>What's Happening</span>
      </div>
    </div>

    <div class="hero-heading">
      <div class="hero-line"></div>

      <div class="hero-copy">
        <h1>
          More Than<br />
          <span>A Meal</span>
        </h1>

        <p>
          Stories, events, partnerships, and the people making a difference
          in the communities we call home.
        </p>
      </div>
    </div>

  </div>
</section>
</section>

<section class="community-content">
  <div class="community-inner">


    @if (loading) {
      <div class="community-state">
        <p>Loading community stories...</p>
      </div>
    }

    @else if (loadError) {
      <div class="community-state">
        <h3>Community stories are unavailable.</h3>
        <p>Please check back again soon.</p>
      </div>
    }

    @else if (posts.length === 0) {
      <div class="community-state">
        <h3>More stories are coming soon.</h3>
        <p>
          Check back for local events, partnerships, fundraisers and
          community highlights.
        </p>
      </div>
    }

    @else {
      <div class="community-feed">

        @for (post of posts; track post.id) {
          <article class="community-post">

            <div class="post-content">
              <time class="post-date">
                {{ post.date | date:'MMMM d, y' }}
              </time>

              <h3>{{ post.title }}</h3>

              <p>{{ post.description }}</p>

              @if (post.link) {
                <a
                  class="post-link"
                  [href]="post.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn More
                  <span>→</span>
                </a>
              }
            </div>

            @if (post.imageUrl) {
              <div class="post-image">
                <img
                  [src]="post.imageUrl"
                  [alt]="post.title"
                />
              </div>
            }

          </article>
        }

      </div>
    }

  </div>
  <div class="community-cta">
    <h2 style="color: var(--mc-light);">
      Want to Partner With Us?
    </h2>

    <p>
      We're always looking for new ways to give back. If you have a community
      initiative we should know about, let's talk.
    </p>

    @if (contactSettings?.contactEmail) {
      <a
        [href]="communityEmailLink"
        class="cta-btn"
      >
        Reach Out →
      </a>
    }
  </div>
</section>
